import {EstimateState} from '@/model/api';
import {ParameterValues} from '@/model/api/parameters';
import {Parameters} from '@/model/offline/storage/ParameterStorage';
import {fromPairs, isEqual} from 'lodash-es';

/**
 * Manages parameters that were submitted, but could not be synced with
 * server because of lost connection
 */
export class StagedParameters {
    public static readonly STORAGE_KEY = 'stagedParameters';

    constructor(private readonly parameters: Parameters) {
    }

    /**
     * Saves changes not synchronized with server to storage
     */
    public stageSegment(parameters: ParameterValues): void {
        Object.entries(parameters).forEach(([parameterName, value]) => {
            this.parameters.add(parameterName, value);
        });
    }

    /**
     * Returns diff of staged changes and fresh estimate data from server
     */
    public diff(estimate: EstimateState): ParameterValues {
        const stagedChanges = this.parameters.getAll();

        return fromPairs(
            Object.entries(stagedChanges)
                .filter(([parameterName, value]) => ! isEqual(value, estimate.parameters[parameterName].value)),
        );
    }

    public clear(): void {
        this.parameters.removeAll();
    }
}
